import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIftttComponent } from './simple-icons-ifttt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIftttComponent ],
    exports:      [ SimpleIconsIftttComponent ],
    bootstrap:    []
})
export class SimpleIconsIftttModule {}
